<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10 col-xl-11">
                <!-- Header -->

                <div class="header mb-md-5">
                    <div class="header-body">
                        <!-- Pretitle -->
                        <h6 class="header-pretitle">{{ $t('General') }}</h6>

                        <!-- Title -->
                        <h1 class="header-title display-4">{{ $t('Settings') }}</h1>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-6">
                        <permission-check resource="service" create v-if="$loadModule('services')">
                            <router-link :to="{name:'company.services'}" class="h1 header-title">
                                {{ $t('Services') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.services') }}
                            </div>
                        </permission-check>
                        <permission-check resource="my-team" create>
                            <router-link class="h1 header-title" :to="{name:'people.team'}">
                                {{ $t('Team') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.team') }}
                            </div>
                        </permission-check>
                        <permission-check resource="company" edit>
                            <router-link class="h1 header-title" :to="{name:'company.profile'}">
                                {{ $t('Company') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.company') }}
                            </div>
                        </permission-check>
                        <permission-check resource="documents" create v-if="$loadModule('documents')">
                            <router-link :to="{name:'company.documents'}" class="h1 header-title">
                                {{ $t('Documents') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.documents') }}
                            </div>
                        </permission-check>
                        <permission-check resource="sources" create v-if="$loadModule('customers')">
                            <router-link class="h1 header-title" :to="{name:'company.sources'}">
                                {{ $t('Sources') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.sources') }}
                            </div>
                        </permission-check>

                        <permission-check resource="tags" create>
                            <router-link class="h1 header-title" :to="{name:'company.tags'}">
                                {{ $t('Tags') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.tags') }}
                            </div>
                        </permission-check>
                        <permission-check resource="work-place" create>
                            <router-link class="h1 header-title" :to="{name:'company.work-places'}">
                                {{ $t('Workplaces') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.work-places') }}
                            </div>
                        </permission-check>
                        <permission-check resource="roles" create>
                            <router-link class="h1 header-title" :to="{name:'company.roles'}">
                                {{ $t('Roles') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.roles') }}
                            </div>
                        </permission-check>
                        <permission-check resource="timeline" view>
                            <router-link class="h1 header-title" :to="{name:'company.userActivities'}">
                                {{ $t('User Activities') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.user-activities') }}
                            </div>
                        </permission-check>
                        <router-link class="h1 header-title" :to="{name:'company.trash'}">
                            {{ $t('Trash') }}
                        </router-link>
                        <div class="small header-subtitle mb-5">
                            {{ $t('settingsDesc.trash') }}
                        </div>
                    </div>
                    <div class="col-6" v-if="$loadModule('treatments')">
                        <permission-check resource="specialty" create>
                            <router-link class="h1 header-title" :to="{name:'company.specialty'}">
                                {{ $t('Specialties') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.specialties') }}
                            </div>
                        </permission-check>

                        <permission-check resource="icd" create>
                            <router-link class="h1 header-title" :to="{name:'company.icd'}">
                                {{ $t('ICD-10') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.icd10') }}
                            </div>
                        </permission-check>
                        <permission-check resource="cdb" create>
                            <router-link class="h1 header-title" :to="{name:'company.cdb'}">
                                {{ $t('Complaints') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.complaints') }}
                            </div>
                        </permission-check>
                        <permission-check resource="odb" create>
                            <router-link class="h1 header-title" :to="{name:'company.odb'}">
                                {{ $t('Objectively') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.objectively') }}
                            </div>
                        </permission-check>
                        <permission-check resource="manipulations" create>
                            <router-link class="h1 header-title" :to="{name:'company.manipulations'}">
                                {{ $t('Manipulations') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.manipulations') }}
                            </div>
                        </permission-check>
                        <permission-check resource="presets" create>
                            <router-link class="h1 header-title" :to="{name:'company.presets'}">
                                {{ $t('Presets') }}
                            </router-link>
                            <div class="small header-subtitle mb-5">
                                {{ $t('settingsDesc.presets') }}
                            </div>
                        </permission-check>
                        <router-link class="h1 header-title" :to="{name:'company.configurator'}">
                            {{ $t('Configurator') }}
                        </router-link>
                        <div class="small header-subtitle mb-5">
                            {{ $t('settingsDesc.configurator') }}
                        </div>
						<permission-check resource="text-templates" create v-if="$loadModule('textTreatments')">
							<router-link class="h1 header-title" :to="{name:'company.textTemplates'}">
								{{ $t('Text Templates') }}
							</router-link>
							<div class="small header-subtitle mb-5">
								{{ $t('settingsDesc.textTemplates') }}
							</div>
						</permission-check>
                        <router-link :to="{name:'company.sessions'}" class="h1 header-title">
                            {{ $t('sessions.sessions') }}
                        </router-link>
                        <div class="small header-subtitle mb-5">
                            {{ $t('settingsDesc.sessions') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    computed: {},
    created() {
    },

    methods: {},
}
</script>
